import { apiSlice } from '../../../../app/apiSlice';
import { formatDateToISO } from '../../../../utils/formatDate';
import configSiteUrls from '../../configs/configSiteUrls';
import { AcessoInformacaoListPublicResponse } from './types/AcessoInformacao';
import { AcessoInformacaoAnexo } from './types/AcessoInformacaoAnexo';

//usei o acessoInformacaoAnexo como base

const endpointUrl = configSiteUrls.SITE_ACESSO_INFORMACAO_EP;
const endpointUrlPublic = configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_EP;

interface Params {
  data_inicial?: string | null;
  data_final?: string | null;
  search?: string | null;
  page?: number;
  apply?: boolean;
  exercicio?: string | null;
  tipo?: string | null;
}

function getacessoInformacaosPublic({ data_inicial, data_final, search, page = 1, exercicio, tipo }: Params) {
  const queryParams = new URLSearchParams();

  if (search) queryParams.set('search', search);
  if (data_inicial) queryParams.set('dataInicial', formatDateToISO(data_inicial));
  if (data_final) queryParams.set('dataFinal', formatDateToISO(data_final));
  queryParams.set('page', page.toString());
  if (exercicio) queryParams.set('exercicio', exercicio);
  if (tipo) queryParams.set('tipo', tipo);

  return {
    url: `${endpointUrlPublic}/all?${queryParams.toString()}`,
    method: 'GET'
  };
}

function getAcessoInformacaoAnexos({ idAcessoInformacaoAnexo }: { idAcessoInformacaoAnexo: string }) {
  if (!idAcessoInformacaoAnexo) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idAcessoInformacaoAnexo}&respostaAnexo=false`,
    method: 'GET'
  };
}

function getAcessoInformacaoAnexosResposta({ idAcessoInformacaoAnexo }: { idAcessoInformacaoAnexo: string }) {
  if (!idAcessoInformacaoAnexo) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idAcessoInformacaoAnexo}&respostaAnexo=true`,
    method: 'GET'
  };
}

function addAnexos(formData: FormData) {
  return {
    url: `${endpointUrlPublic}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

//addAnexosResposta
function addAnexosResposta(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function removeAnexosExcluidos(formData: FormData) {
  return {
    url: `${endpointUrl}/remover-anexos`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

export const acessoInformacaoAnexoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getAcessoInformacaoAnexos: query<AcessoInformacaoAnexo[], { idAcessoInformacaoAnexo: string }>({
      query: getAcessoInformacaoAnexos,
      providesTags: ['AcessoInformacaoAnexoSite']
    }),
    getAcessoInformacaoAnexosResposta: query<AcessoInformacaoAnexo[], { idAcessoInformacaoAnexo: string }>({
      query: getAcessoInformacaoAnexosResposta,
      providesTags: ['AcessoInformacaoAnexoSite']
    }),
    getacessoInformacaosPublic: query<AcessoInformacaoListPublicResponse, Params>({
      query: getacessoInformacaosPublic,
      providesTags: ['AcessoInformacaoAnexoSite']
    }),

    addAcessoInformacaoAnexos: mutation<void, FormData>({
      query: addAnexos,
      invalidatesTags: ['AcessoInformacaoAnexoSite']
    }),
    addAcessoInformacaoAnexosResposta: mutation<void, FormData>({
      query: addAnexosResposta,
      invalidatesTags: ['AcessoInformacaoAnexoSite']
    }),
    removeAcessoInformacaoAnexoExcluido: mutation<void, FormData>({
      query: removeAnexosExcluidos,
      invalidatesTags: ['AcessoInformacaoAnexoSite']
    })
  })
});
export const {
  useGetAcessoInformacaoAnexosQuery,
  useAddAcessoInformacaoAnexosMutation,
  useRemoveAcessoInformacaoAnexoExcluidoMutation,
  useLazyGetAcessoInformacaoAnexosQuery,
  useGetAcessoInformacaoAnexosRespostaQuery,
  useGetacessoInformacaosPublicQuery,
  useLazyGetacessoInformacaosPublicQuery,
  useAddAcessoInformacaoAnexosRespostaMutation
} = acessoInformacaoAnexoApiSlice;
